import { useRouteChangeStart } from '@/lib/hooks';
import FlyOut from './Flyout';

import type { FunctionComponent } from 'react';
import type { DesktopMenuProps } from './types';

/**
 * Primary UI component for user interaction
 */
export const DesktopMenu: FunctionComponent<DesktopMenuProps> = ({
  setOpen,
  open,
}: DesktopMenuProps) => {
  useRouteChangeStart(() => setOpen(-1));

  return (
    <div aria-label="Top" className="u-wrapper !static z-50 hidden lg:block">
      <FlyOut setOpen={setOpen} open={open} />
    </div>
  );
};
